/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  DBHistory,
  DBHistoryOptional,
  DBHistoryMetaI,
  DBHistoryTrackedI,
} from "./dbhistory";
import { DBHistoryTracked, DBHistoryMeta } from "./dbhistory";

/**
 *
 * @export
 * @interface PersonInternal
 */
export interface PersonInternalOptional extends DBHistoryOptional {
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  veteranEligible?: string;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  sailingExp?: string;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  orgContact?: string;
}

export interface PersonInternal extends PersonInternalOptional, DBHistory {
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  updatedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  updatedBy?: string;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  createdOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  createdBy?: string;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  veteranEligible?: string;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  sailingExp?: string;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  orgContact?: string;
}

export interface PersonInternalTrackedI extends DBHistoryOptional {
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  updatedOn?: Date;
  updatedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  updatedBy?: string;
  updatedByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  createdOn?: Date;
  createdOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  createdBy?: string;
  createdByIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  veteranEligible?: string;
  veteranEligibleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  sailingExp?: string;
  sailingExpIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonInternal
   */
  orgContact?: string;
  orgContactIsSet: boolean;
}

transformDatesMap.set("PersonInternal", function (model: PersonInternal) {
  if (typeof model.updatedOn == "string")
    model.updatedOn = new Date(model.updatedOn);
  if (typeof model.createdOn == "string")
    model.createdOn = new Date(model.createdOn);
});

export type PersonInternalMetaI = MetaType<{
  //isDate: false
  //isDatetime: true
  updatedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  updatedBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  createdOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  createdBy: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  veteranEligible: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sailingExp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  orgContact: PropertyMeta<MetaTypeBase<string>>;
}>;

export var PersonInternalMeta: PersonInternalMetaI = {} as PersonInternalMetaI;
PersonInternalMeta = typeMeta("PersonInternal", {
  updatedOn: propertyMeta("updatedOn", false, false, false, MetaTypesBase.Date),
  updatedBy: propertyMeta(
    "updatedBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  createdOn: propertyMeta("createdOn", false, false, false, MetaTypesBase.Date),
  createdBy: propertyMeta(
    "createdBy",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  veteranEligible: propertyMeta(
    "veteranEligible",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sailingExp: propertyMeta(
    "sailingExp",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  orgContact: propertyMeta(
    "orgContact",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = PersonInternalMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DBHistoryMeta]);
  metaI.updatedOn.inheritedFrom = DBHistoryMeta.updatedOn;
  metaI.updatedBy.inheritedFrom = DBHistoryMeta.updatedBy;
  metaI.createdOn.inheritedFrom = DBHistoryMeta.createdOn;
  metaI.createdBy.inheritedFrom = DBHistoryMeta.createdBy;
});

export class PersonInternalTracked
  extends DBHistoryTracked
  implements PersonInternalTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  updatedOn__I?: Date = undefined;
  updatedOnIsSet: boolean = false;
  set updatedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.updatedOn__I = v;
      this.updatedOnIsSet = true;
    } else {
      this.updatedOn__I = v || undefined;
      this.updatedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedOn() {
    return this.updatedOn__I;
  }
  updatedBy__I?: string = undefined;
  updatedByIsSet: boolean = false;
  set updatedBy(v: undefined | string) {
    if (v !== undefined) {
      this.updatedBy__I = v;
      this.updatedByIsSet = true;
    } else {
      this.updatedBy__I = v || undefined;
      this.updatedByIsSet = false;
    }
    this.changeTracker = true;
  }
  get updatedBy() {
    return this.updatedBy__I;
  }
  createdOn__I?: Date = undefined;
  createdOnIsSet: boolean = false;
  set createdOn(v: undefined | Date) {
    if (v !== undefined) {
      this.createdOn__I = v;
      this.createdOnIsSet = true;
    } else {
      this.createdOn__I = v || undefined;
      this.createdOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdOn() {
    return this.createdOn__I;
  }
  createdBy__I?: string = undefined;
  createdByIsSet: boolean = false;
  set createdBy(v: undefined | string) {
    if (v !== undefined) {
      this.createdBy__I = v;
      this.createdByIsSet = true;
    } else {
      this.createdBy__I = v || undefined;
      this.createdByIsSet = false;
    }
    this.changeTracker = true;
  }
  get createdBy() {
    return this.createdBy__I;
  }
  veteranEligible__I?: string = undefined;
  veteranEligibleIsSet: boolean = false;
  set veteranEligible(v: undefined | string) {
    if (v !== undefined) {
      this.veteranEligible__I = v;
      this.veteranEligibleIsSet = true;
    } else {
      this.veteranEligible__I = v || undefined;
      this.veteranEligibleIsSet = false;
    }
    this.changeTracker = true;
  }
  get veteranEligible() {
    return this.veteranEligible__I;
  }
  sailingExp__I?: string = undefined;
  sailingExpIsSet: boolean = false;
  set sailingExp(v: undefined | string) {
    if (v !== undefined) {
      this.sailingExp__I = v;
      this.sailingExpIsSet = true;
    } else {
      this.sailingExp__I = v || undefined;
      this.sailingExpIsSet = false;
    }
    this.changeTracker = true;
  }
  get sailingExp() {
    return this.sailingExp__I;
  }
  orgContact__I?: string = undefined;
  orgContactIsSet: boolean = false;
  set orgContact(v: undefined | string) {
    if (v !== undefined) {
      this.orgContact__I = v;
      this.orgContactIsSet = true;
    } else {
      this.orgContact__I = v || undefined;
      this.orgContactIsSet = false;
    }
    this.changeTracker = true;
  }
  get orgContact() {
    return this.orgContact__I;
  }
  constructor(config?: PersonInternalOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PersonInternalOptional,
    options?: AssignOptions,
  ): PersonInternalTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.updatedOn && this.updatedOnApplyFilter(optionsRequired.filter)) {
      this.updatedOn = config.updatedOn;
      if (optionsRequired.unassign) this.updatedOnIsSet = false;
      else this.updatedOnIsSet = true;
    }
    if (config.updatedBy && this.updatedByApplyFilter(optionsRequired.filter)) {
      this.updatedBy = config.updatedBy;
      if (optionsRequired.unassign) this.updatedByIsSet = false;
      else this.updatedByIsSet = true;
    }
    if (config.createdOn && this.createdOnApplyFilter(optionsRequired.filter)) {
      this.createdOn = config.createdOn;
      if (optionsRequired.unassign) this.createdOnIsSet = false;
      else this.createdOnIsSet = true;
    }
    if (config.createdBy && this.createdByApplyFilter(optionsRequired.filter)) {
      this.createdBy = config.createdBy;
      if (optionsRequired.unassign) this.createdByIsSet = false;
      else this.createdByIsSet = true;
    }
    if (
      config.veteranEligible &&
      this.veteranEligibleApplyFilter(optionsRequired.filter)
    ) {
      this.veteranEligible = config.veteranEligible;
      if (optionsRequired.unassign) this.veteranEligibleIsSet = false;
      else this.veteranEligibleIsSet = true;
    }
    if (
      config.sailingExp &&
      this.sailingExpApplyFilter(optionsRequired.filter)
    ) {
      this.sailingExp = config.sailingExp;
      if (optionsRequired.unassign) this.sailingExpIsSet = false;
      else this.sailingExpIsSet = true;
    }
    if (
      config.orgContact &&
      this.orgContactApplyFilter(optionsRequired.filter)
    ) {
      this.orgContact = config.orgContact;
      if (optionsRequired.unassign) this.orgContactIsSet = false;
      else this.orgContactIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonInternalTrackedI {
    const cloned = {} as PersonInternalTrackedI;
    if (
      this.updatedOnIsSetDeep() &&
      this.updatedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedOnIsSet = true;
      cloned.updatedOn = this.updatedOn;
    } else {
      //cloned.updatedOnIsSet = false
    }
    if (
      this.updatedByIsSetDeep() &&
      this.updatedByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.updatedByIsSet = true;
      cloned.updatedBy = this.updatedBy;
    } else {
      //cloned.updatedByIsSet = false
    }
    if (
      this.createdOnIsSetDeep() &&
      this.createdOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdOnIsSet = true;
      cloned.createdOn = this.createdOn;
    } else {
      //cloned.createdOnIsSet = false
    }
    if (
      this.createdByIsSetDeep() &&
      this.createdByApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.createdByIsSet = true;
      cloned.createdBy = this.createdBy;
    } else {
      //cloned.createdByIsSet = false
    }
    if (
      this.veteranEligibleIsSetDeep() &&
      this.veteranEligibleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.veteranEligibleIsSet = true;
      cloned.veteranEligible = this.veteranEligible;
    } else {
      //cloned.veteranEligibleIsSet = false
    }
    if (
      this.sailingExpIsSetDeep() &&
      this.sailingExpApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sailingExpIsSet = true;
      cloned.sailingExp = this.sailingExp;
    } else {
      //cloned.sailingExpIsSet = false
    }
    if (
      this.orgContactIsSetDeep() &&
      this.orgContactApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orgContactIsSet = true;
      cloned.orgContact = this.orgContact;
    } else {
      //cloned.orgContactIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonInternalTrackedI {
    if (!this.updatedOnApplyFilter(filter)) this.updatedOnIsSet = false;

    if (!this.updatedByApplyFilter(filter)) this.updatedByIsSet = false;

    if (!this.createdOnApplyFilter(filter)) this.createdOnIsSet = false;

    if (!this.createdByApplyFilter(filter)) this.createdByIsSet = false;

    if (!this.veteranEligibleApplyFilter(filter))
      this.veteranEligibleIsSet = false;

    if (!this.sailingExpApplyFilter(filter)) this.sailingExpIsSet = false;

    if (!this.orgContactApplyFilter(filter)) this.orgContactIsSet = false;

    return this;
  }
  updatedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonInternalMeta.updatedOn,
      PersonInternalMeta,
      this.updatedOn,
      this,
    );
  }
  updatedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedOnIsSet && this.updatedOnApplyFilter(filter)) return true;

    return false;
  }
  updatedByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonInternalMeta.updatedBy,
      PersonInternalMeta,
      this.updatedBy,
      this,
    );
  }
  updatedByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.updatedByIsSet && this.updatedByApplyFilter(filter)) return true;

    return false;
  }
  createdOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonInternalMeta.createdOn,
      PersonInternalMeta,
      this.createdOn,
      this,
    );
  }
  createdOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdOnIsSet && this.createdOnApplyFilter(filter)) return true;

    return false;
  }
  createdByApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonInternalMeta.createdBy,
      PersonInternalMeta,
      this.createdBy,
      this,
    );
  }
  createdByIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.createdByIsSet && this.createdByApplyFilter(filter)) return true;

    return false;
  }
  veteranEligibleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonInternalMeta.veteranEligible,
      PersonInternalMeta,
      this.veteranEligible,
      this,
    );
  }
  veteranEligibleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.veteranEligibleIsSet && this.veteranEligibleApplyFilter(filter))
      return true;

    return false;
  }
  sailingExpApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonInternalMeta.sailingExp,
      PersonInternalMeta,
      this.sailingExp,
      this,
    );
  }
  sailingExpIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sailingExpIsSet && this.sailingExpApplyFilter(filter)) return true;

    return false;
  }
  orgContactApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonInternalMeta.orgContact,
      PersonInternalMeta,
      this.orgContact,
      this,
    );
  }
  orgContactIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orgContactIsSet && this.orgContactApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.updatedOnIsSetDeep(filter)) return true;
    if (this.updatedByIsSetDeep(filter)) return true;
    if (this.createdOnIsSetDeep(filter)) return true;
    if (this.createdByIsSetDeep(filter)) return true;
    if (this.veteranEligibleIsSetDeep(filter)) return true;
    if (this.sailingExpIsSetDeep(filter)) return true;
    if (this.orgContactIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
